import styled from 'styled-components'

import { black } from '~/shared/styles/colors'
import { baseFont } from '~/shared/styles/font'
import { flexRow } from '~/shared/styles/layout'

/**
 *
 */

export const Count = styled.span`
  ${baseFont}
  font-weight: bold;
  color: ${black};
  margin-right: 4px;
`

export const LabelCounter = styled.div`
  width: 100%;
  ${flexRow}
  justify-content: space-between;
`

export const LabelName = styled.div`
  ${flexRow}
  flex: 1;
  text-transform: capitalize;

  & > * {
    margin-right: 8px;
  }
`
